import {
  SalesEndDate,
  SalesEndStatusCustomDate,
  SalesEndStatusEventsStart,
  SalesStartDate,
  SalesStartStatusAfterOffer,
  SalesStartStatusCustomDate,
} from '@components/admission-modal/admission/admission.type';
import { Admission, ADMISSION_STATUS_HIDDEN_BY_TRIGGER } from '@domain/admission';
import { fromBackend } from '@utils/map-date/from-backend';
import { toBackend } from '@utils/map-date/to-backend';
import moment from 'moment-timezone';

export const formatSalesTimeToBackend = ({
  offer,
  salesEndDate,
  salesEndTime,
  salesStartDate,
  salesStartTime,
  eventStartingTime,
  eventEndingTime,
  timezone,
  salesEndType,
  salesStartType,
}: {
  offer?: Admission | null;
  salesEndDate?: moment.Moment | null;
  salesEndTime?: string;
  salesStartDate?: moment.Moment | null;
  salesStartTime?: string;
  eventStartingTime: number;
  eventEndingTime: number;
  timezone: string;
  salesEndType: SalesEndDate | '';
  salesStartType: SalesStartDate | '';
}) => {
  let startHours = 0;
  let startMinutes = 0;
  if (salesStartTime) {
    startHours = parseInt(salesStartTime.split(':')[0]);
    startMinutes = parseInt(salesStartTime.split(':')[1]);
  } else if (offer?.salesTime?.openingTime) {
    startHours = fromBackend(offer.salesTime.openingTime, timezone).hours();
    startMinutes = fromBackend(offer.salesTime.openingTime, timezone).minutes();
  }

  let endHours = 0;
  let endMinutes = 0;
  if (salesEndTime) {
    endHours = parseInt(salesEndTime.split(':')[0]);
    endMinutes = parseInt(salesEndTime.split(':')[1]);
  } else if (offer?.salesTime.closingTime) {
    endHours = fromBackend(offer.salesTime.closingTime, timezone).hours();
    endMinutes = fromBackend(offer.salesTime.closingTime, timezone).minutes();
  }

  const stardDate = salesStartDate ?? fromBackend(offer?.salesTime.openingTime ?? 0);
  const endDate = salesEndDate ?? fromBackend(offer?.salesTime.closingTime ?? 0);

  let closingTime = fromBackend(eventEndingTime, timezone);
  if (salesEndType === SalesEndStatusCustomDate)
    closingTime = moment(endDate).tz(timezone).hours(endHours).minutes(endMinutes).seconds(0);
  else if (salesEndType === SalesEndStatusEventsStart) closingTime = fromBackend(eventStartingTime, timezone);

  let openingTime = moment().tz(timezone);
  if (salesStartType === SalesStartStatusCustomDate) {
    openingTime = moment(stardDate).tz(timezone).hours(startHours).minutes(startMinutes).seconds(0);
  } else if (salesStartType === SalesStartStatusAfterOffer) {
    const isHiddenByTrigger = offer?.status === ADMISSION_STATUS_HIDDEN_BY_TRIGGER;
    const isOfferTriggered = offer?.salesTime.openingTime && !isHiddenByTrigger;
    if (offer?.salesTime.openingTime && isOfferTriggered) openingTime = fromBackend(offer.salesTime.openingTime);
  }

  return {
    ...((salesStartDate || salesStartTime) && { openingTime: toBackend(openingTime) }),
    ...((salesEndDate || salesEndTime) && { closingTime: toBackend(closingTime) }),
  };
};
